import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {NgxFiltersParentBase} from "../ngx-filters-parent-base";
import {isPlatformBrowser} from "@angular/common";
import {Filter, FilterTypes, NgxApplyFilterResult} from "../ngx-types";
import {NgxDateFilterComponent} from "../components/date/ngx-date-filter/ngx-date-filter.component";
import {NgxNumberFilterComponent} from '../components/number-box/ngx-number-filter/ngx-number-filter.component';

@Component({
  selector: 'ngx-chip-filter',
  templateUrl: './ngx-chip-filter.component.html',
  styleUrls: ['./ngx-chip-filter.component.scss', '../ngx-filters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NgxChipFilterComponent extends NgxFiltersParentBase implements OnInit, AfterViewInit {
  isOpen = false;
  @Input() filteredFilters: Filter[];
  @Output() filteredFiltersChange: EventEmitter<Filter[]>;
  @Input() afterFilterChange: (filter: Filter) => Promise<any>;
  @Input() hasClearAll = true;
  @Output() filterChange: EventEmitter<Filter> = new EventEmitter<Filter>();
  @Input() filters: Filter[] = [];
  @Input() showSelectedValue = false;
  @Output() afterClose = new EventEmitter<any>();
  @Output() afterOpen = new EventEmitter<any>();
  selectedFilter: Filter;
  @Output() apply = new EventEmitter<NgxApplyFilterResult>();
  platformId: any;
  @ViewChild('filterDialogRef') filterDialogRef: ElementRef<HTMLElement>;
  @ViewChild('dateFilter') dateFilter: NgxDateFilterComponent;
  @ViewChild('numberBox') numberBox: NgxNumberFilterComponent;
  displayLabel

  constructor(injector: Injector) {
    super(injector);
    this.platformId = injector.get(PLATFORM_ID);
  }

  close(): void {
    const index = this.innerFilters.indexOf(this.selectedFilter);
    if (index >= 0) {
      const filter = this.filters.find(z => z.field == this.selectedFilter.field);
      if (filter) {
        this.innerFilters[index] = this.getClone([filter])[0];
      }
    }
    this.isOpen = false;
    this.selectedFilter = null;
    this.afterClose.emit();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  showFilter(filter: Filter): void {
    this.selectedFilter = this.innerFilters.find(z => z.field == filter.field);
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        document.documentElement.appendChild(this.filterDialogRef.nativeElement);
      }
    });
    this.afterOpen.emit(filter);
    this.isOpen = true;
  }

  afterApply = () => {
    this.isOpen = false;
    this.selectedFilter = null;
    this.afterClose.emit();
  }

  onClear(filter: Filter): void {
    this.filtersService.clearFilter(filter);
    this.applyFilter(filter);

  }

  onConditionChange(filterType: FilterTypes): void {
    if (filterType == FilterTypes.DateTime && this.dateFilter) {
      this.dateFilter.refreshLabels();
    }
    if (filterType == FilterTypes.Number && this.numberBox)
      this.numberBox.refreshLabels();

  }

  ngAfterViewInit(): void {
  }

  setTitle(title): any {
    setTimeout(() => {
      title.title = title.textContent?.replace(/\n/g, '') ?? '';
    })
  }

  // afterApply(): void {
  //   this.close();
  // }


}
